/*
 * Copyright 2022 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
import axios from "axios";
import { SecurityConfiguration } from "../dto/security.interfaces";

const BASE_URL_SECURITY = "/api/security";

export const getSecurityConfiguration =
    async (): Promise<SecurityConfiguration> => {
        const response = await axios.get(`${BASE_URL_SECURITY}/config`);

        return response.data;
    };
